import _ from 'lodash';
import React from 'react';

import {formatDate} from 'utils/datetime';

import Avatar from 'components/Avatar';
import VisibleIf from 'components/VisibleIf';

import briefcaseIcon from './assets/briefcase.svg';
import cakeIcon from './assets/cake.svg';
import worldIcon from './assets/world.svg';
import phoneIcon from 'assets/icons/phone-call.svg';

import {PERMISSIONS} from 'ducks/auth';

import './styles.css';

const IconAndTextOrWaiting = ({icon, text}) => (
  <div className="container">
    <img src={icon} alt="Icon" />
    {!_.isEmpty(text) && <div className="text">{text}</div>}
    {_.isEmpty(text) && (
      <div className="more">
        <div className="waiting">Waiting...</div>
      </div>
    )}
  </div>
);

const TenantBox = ({tenant, locationRef, onClick}) => (
  <div className="TenantBox" onClick={onClick}>
    <div className="baseInfo">
      <Avatar
        className="avatar"
        url={tenant.internalAvatarCropped || tenant.avatarCropped}
        initials={tenant.initials}
        key={tenant.internalAvatarCropped || tenant.avatarCropped}
      />
      <div className="name">{tenant.fullName}</div>
      <div className="email">{tenant.email}</div>
    </div>
    <div className="secondaryInfo">
      <IconAndTextOrWaiting icon={phoneIcon} text={tenant.phone} />
      <VisibleIf
        permission={PERMISSIONS.VIEW_MEMBER_DETAILS}
        locationRef={locationRef}>
        <IconAndTextOrWaiting icon={briefcaseIcon} text={tenant.currentJob} />
        <IconAndTextOrWaiting icon={worldIcon} text={tenant.nationality} />
        <IconAndTextOrWaiting
          icon={cakeIcon}
          text={tenant.birthday && formatDate(tenant.birthday)}
        />
      </VisibleIf>
    </div>
  </div>
);

export default TenantBox;
